export default __webpack_public_path__ + "static/bubblesT-08919b906ddda7596c396b512c69116c.png";